










































import { View } from 'client-website-ts-library/plugins';
import { Component, Mixins } from 'vue-property-decorator';
import ListingSearch from '../components/ListingSearch.vue';

@Component({
  components: {
    ListingSearch,
  },
})
export default class OurDifference extends Mixins(View) {}
